/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { OrderTrackingListRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { OrderTrackingListResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * OrderTrackingListApi - axios parameter creator
 * @export
 */
export const OrderTrackingListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the Order List detail
         * @summary Get the Order List detail
         * @param {string} storeId The store identifier.
         * @param {OrderTrackingListRequest} orderTrackingListRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderTrackingList: async (storeId: string, orderTrackingListRequest: OrderTrackingListRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('orderTrackingList', 'storeId', storeId)
            // verify required parameter 'orderTrackingListRequest' is not null or undefined
            assertParamExists('orderTrackingList', 'orderTrackingListRequest', orderTrackingListRequest)
            const localVarPath = `/store/{storeId}/order/orderTrackingList`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderTrackingListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderTrackingListApi - functional programming interface
 * @export
 */
export const OrderTrackingListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderTrackingListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the Order List detail
         * @summary Get the Order List detail
         * @param {string} storeId The store identifier.
         * @param {OrderTrackingListRequest} orderTrackingListRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderTrackingList(storeId: string, orderTrackingListRequest: OrderTrackingListRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTrackingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderTrackingList(storeId, orderTrackingListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderTrackingListApi - factory interface
 * @export
 */
export const OrderTrackingListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderTrackingListApiFp(configuration)
    return {
        /**
         * Get the Order List detail
         * @summary Get the Order List detail
         * @param {string} storeId The store identifier.
         * @param {OrderTrackingListRequest} orderTrackingListRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderTrackingList(storeId: string, orderTrackingListRequest: OrderTrackingListRequest, options?: any): AxiosPromise<OrderTrackingListResponse> {
            return localVarFp.orderTrackingList(storeId, orderTrackingListRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderTrackingListApi - object-oriented interface
 * @export
 * @class OrderTrackingListApi
 * @extends {BaseAPI}
 */
export class OrderTrackingListApi extends BaseAPI {
    /**
     * Get the Order List detail
     * @summary Get the Order List detail
     * @param {string} storeId The store identifier.
     * @param {OrderTrackingListRequest} orderTrackingListRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTrackingListApi
     */
    public orderTrackingList(storeId: string, orderTrackingListRequest: OrderTrackingListRequest, options?: any) {
        return OrderTrackingListApiFp(this.configuration).orderTrackingList(storeId, orderTrackingListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
